






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CourseParam, ICourseTabMenu } from '../../types/types';
import SelectPopover from '@/components/SelectPopover.vue';

@Component({ components: { SelectPopover } })
export default class TabMenu extends Vue {
  @Prop() currentTabIndex!: number;

  @Prop() tabs!: ICourseTabMenu[];

  tabIndex = this.currentTabIndex;

  onValueChange(value: CourseParam) {
    this.tabs.forEach((tab, i) => tab.key === value && this.emitValue(tab.key, i));
  }

  emitValue(param: CourseParam, i: number) {
    if (this.tabIndex !== i) {
      this.tabIndex = i;
      this.$emit('change-tab', param, i);
    }
  }
}
